import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export function MainV2({
  collapsed,
  expandedWidth,
  collapsedWidth,
  children,
}: {
  collapsed: boolean;
  expandedWidth: string;
  collapsedWidth: string;
  children?: React.ReactNode;
}) {
  const theme = useTheme();
  const drawerWidth = collapsed ? collapsedWidth : expandedWidth;

  return (
    <Box
      sx={{
        position: "relative",
        width: `calc(100% - ${drawerWidth})`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(["margin", "width"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        ...(!collapsed && {
          transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }),
      }}
    >
      {children}
    </Box>
  );
}
